// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_AddAdvancesBatchInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/add_advances_batch
 *
 * Validates input for creating multiple payroll advances at once.
 */
import { registerContract } from './validate'

export interface Payroll_AddAdvancesBatchInput {
period_id: number
franchise_id: number
recebimento_ids: number[]
notes?: string
}

registerContract('Payroll_AddAdvancesBatchInput', {
  period_id:       { type: 'number',  required: true },
  franchise_id:    { type: 'number',  required: true },
  recebimento_ids: { type: 'array',   required: true },
  notes:           { type: 'string',  required: false },
})
